import { Asset, type AppBase, type Texture } from 'playcanvas';
import {
  MeshCollision,
  loadVoxelCollision,
} from '../../submodules/supersplat-viewer/src/collision';
import type { Collision } from '../../submodules/supersplat-viewer/src/collision';
import type { Config } from '../../submodules/supersplat-viewer/src/types';

export function loadSkybox(app: AppBase, url: string): Promise<Asset> {
  return new Promise<Asset>((resolve, reject) => {
    const asset = new Asset(
      'skybox',
      'texture',
      { url },
      { type: 'rgbp', mipmaps: false, addressu: 'repeat', addressv: 'clamp' },
    );
    asset.on('load', () => resolve(asset));
    asset.on('error', (err) => reject(err));
    app.assets.add(asset);
    app.assets.load(asset);
  });
}

export function loadSkyboxIfAny(app: AppBase, config: Config): Promise<void> | undefined {
  const skyboxUrl = config.skyboxUrl;
  if (!skyboxUrl) return undefined;
  return loadSkybox(app, skyboxUrl)
    .then((asset) => {
      app.scene.envAtlas = asset.resource as Texture;
    })
    .catch((err: Error) => {
      console.warn('Failed to load skybox:', err);
    });
}

export function loadCollisionIfAny(app: AppBase, config: Config): Promise<Collision> | undefined {
  const { collisionUrl, collisionBinUrl } = config;
  if (!collisionUrl) return undefined;
  const ext = new URL(collisionUrl, location.href).pathname.split('.').pop()?.toLowerCase();
  if (ext === 'glb') {
    return MeshCollision.fromGlb(app, collisionUrl).catch((err: Error): Collision => {
      console.warn('Failed to load mesh collision:', err);
      throw err;
    });
  }
  return loadVoxelCollision(collisionUrl, collisionBinUrl).catch((err: Error): Collision => {
    console.warn('Failed to load voxel data:', err);
    throw err;
  });
}
